var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{staticClass:"shake-horizontal"},[_c('EspError',{attrs:{"icon":"mdi-close","iconColor":_vm.iconColor,"text":_vm.$t('triesLeftMany')}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }